// src/pages/ContentDetail/components/activity/DecodeActivity.js
import React from 'react';
import { Box, Typography, Grid, Card, alpha, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReadableText from '../../../../components/text/ReadableText';

const DecodeActivity = ({ activity }) => {
  const theme = useTheme();

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom color="text.primary">
        {activity.activityTitle}
      </Typography>

      <Grid container spacing={2}>
        {activity.content.words.map((item, index) => {
          return (
            <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
              <Card
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  bgcolor: theme.palette.background.paper,
                  borderColor: theme.palette.divider,
                  '&:hover': {
                    borderColor: theme.palette.primary.main,
                    bgcolor: alpha(theme.palette.primary.main, 0.05)
                  }
                }}
              >
                <Typography variant="h6" fontWeight={600} color="text.primary">
                  {item.raw}
                </Typography>
                <Divider sx={{ my: 1, borderColor: alpha(theme.palette.common.white, 0.1) }} />
                    <ReadableText text={item.readable} />
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default DecodeActivity;